import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  link: string;
}
export default function ServiceCard({
  title,
  description,
  icon,
  link
}: ServiceCardProps) {
  return <div className="bg-white rounded-lg shadow-md p-6 transition-all hover:shadow-lg border-t-4 border-primary" data-id="element-305">
      <div className="text-primary mb-4" data-id="element-306">{icon}</div>
      <h3 className="text-xl font-serif font-bold text-primary mb-2" data-id="element-307">
        {title}
      </h3>
      <p className="text-slate mb-4" data-id="element-308">{description}</p>
      <Link to={link} className="inline-flex items-center text-primary font-medium hover:text-secondary transition-colors" data-id="element-309">
        Read More <ArrowRight className="ml-1 h-4 w-4" data-id="element-310" />
      </Link>
    </div>;
}